module.exports = __webpack_public_path__ + "img/help-api-docs.0035d99e.svg";